import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function PricingSection() {
  return <section id="angebot" className="scroll-mt-16 bg-brand-alt px-4 py-20 md:py-24" data-id="element-126" data-mp="19jxdvgf8bdcx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-127" data-mp="1ehgrqf80lo4c">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-128" data-mp="1j8p1xdh65dik">
          Limitiertes Angebot
        </p>
        <h2 className="mb-12 mt-4 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-129" data-mp="1na0sbl7va2rt">
          🔥 Spezielles Launch-Angebot
        </h2>
        <div className="rounded-[2rem] border border-brand-line bg-brand-main p-8 shadow-lg md:p-12" data-id="element-130" data-mp="1x8qazg7l7r94">
          <div className="space-y-4 text-left" data-id="element-131" data-mp="227jfwk8t69xo">
            <PriceLine label="10 komplette Bände (Band 1–10)" price="197 €" data-id="element-132" data-mp="227b28q4v30lf" />
            <PriceLine label="5 exklusive Boni" price="128 €" data-id="element-133" data-mp="2vgwfa06pfk0" />
            <div className="flex items-center justify-between gap-4 pt-2 text-sm font-extrabold uppercase tracking-wide text-brand-navy" data-id="element-134" data-mp="7tsbbz5c6g93">
              <span data-id="element-135" data-mp="1mhq0ybk8hihd">Gesamtwert</span>
              <span className="text-brand-gray line-through" data-id="element-136" data-mp="1mirdkkgwed17">325 €</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-line py-8" data-id="element-137" data-mp="1hnvckutoofby">
            <p className="font-display text-6xl font-extrabold tracking-tight text-brand-orange md:text-7xl" data-id="element-138" data-mp="1crn1ptmir8al">
              19 €{' '}
              <span className="text-2xl font-bold text-brand-navy" data-id="element-139" data-mp="17pxm00ocq6g6">EUR</span>
            </p>
          </div>
          <CTAButton animated href="https://musik-startklar.impultienda.ar/checkout" className="w-full py-5" data-id="element-140" data-mp="25d6bs7vdy1nz" />
          <p className="mt-5 text-xs font-semibold text-brand-gray" data-id="element-141" data-mp="1vg1no2hzbw4j">
            Einmalige Zahlung · Sofort-Download · Sichere Bezahlung
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-brand-line pb-4 text-sm" data-id="element-142" data-mp="fzjecm6xlqcy">
      <span className="font-medium" data-id="element-143" data-mp="hit7fbyau29m">{label}</span>
      <span className="shrink-0 font-bold text-brand-gray line-through" data-id="element-144" data-mp="hfx8plemn9k4">
        {price}
      </span>
    </div>;
}